import "bootstrap/dist/css/bootstrap.css";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import interceptorService from "../src/components/Interceptor";
import * as dotenv from 'react-dotenv';
import { loadConfig } from "./config";
import { LocalizationProvider, IntlProvider} from "@progress/kendo-react-intl";
import { loadAppMessages } from "./Localization/KendoLabelLoader";
import LocalizationInitializer from "./Localization/helpers/LocalizationInitializer";
import { LocalizationResource } from "./components/Shared/AppConstants";
import AppLoader from "./AppLoader";

loadConfig().then(() => {
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
});

interceptorService.setupInterceptors(store);
     loadAppMessages().then(() => {
        ReactDOM.render(
            <LocalizationProvider language={LocalizationResource.Default_Language}>
                <IntlProvider locale={LocalizationResource.Default_Language}>
                    <Provider store={store}>
                        <BrowserRouter>
                            <ConnectedRouter history={history}>
                               <AppLoader></AppLoader>
                            </ConnectedRouter>
                        </BrowserRouter>
                    </Provider>
                </IntlProvider>
            </LocalizationProvider>,
            document.getElementById("root")
        );
    });
});